import Swal from "sweetalert2";

export function isUploadAbortedError(error: unknown): boolean {
  const e = error as {
    code?: string;
    name?: string;
    message?: string;
  };
  return (
    e?.code === "ERR_CANCELED" ||
    e?.name === "CanceledError" ||
    e?.name === "AbortError" ||
    (typeof e?.message === "string" && e.message.toLowerCase().includes("canceled"))
  );
}

export function getUploadErrorMessage(error: unknown): string {
  const e = error as {
    response?: { data?: unknown };
    message?: string;
  };
  const d = e?.response?.data;
  if (typeof d === "string" && d.trim()) return d;
  if (d && typeof d === "object") {
    const o = d as { message?: string; error?: string };
    if (typeof o.message === "string" && o.message) return o.message;
    if (typeof o.error === "string" && o.error) return o.error;
  }
  if (typeof e?.message === "string" && e.message) return e.message;
  return "Something went wrong while uploading.";
}

export function isLikelyFileSizeError(message: string, status?: number): boolean {
  if (status === 413) return true;
  const m = message.toLowerCase();
  return (
    m.includes("size") ||
    m.includes("too large") ||
    m.includes("too big") ||
    m.includes("file size") ||
    m.includes("limit") ||
    m.includes("payload") ||
    m.includes("exceed") ||
    m.includes("max") ||
    m.includes("mb") ||
    m.includes("kb")
  );
}

export async function showGalleryUploadErrorPopup(error: unknown): Promise<void> {
  if (isUploadAbortedError(error)) return;

  const status = (error as { response?: { status?: number } })?.response?.status;
  const msg = getUploadErrorMessage(error);
  const sizeRelated = isLikelyFileSizeError(msg, status);

  await Swal.fire({
    icon: "error",
    title: sizeRelated ? "File size not allowed" : "Upload failed",
    text: msg,
    confirmButtonText: "OK",
  });
}
